// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bergmite: PokeData = {
  "id": 712,
  "name": "bergmite",
  "height": 10,
  "weight": 995,
  "base_experience": 61,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "bite",
    "blizzard",
    "recover",
    "harden",
    "sharpen",
    "curse",
    "powder-snow",
    "protect",
    "icy-wind",
    "rapid-spin",
    "crunch",
    "ice-ball",
    "iron-defense",
    "avalanche",
    "ice-shard",
    "ice-fang"
  ],
  "moves": [
    "tackle",
    "bite",
    "blizzard",
    "curse",
    "protect",
    "crunch",
    "avalanche",
    "ice-shard",
    "ice-fang",
    "aurora-veil",
    "ice-wave",
    "ice-punch",
    "chilly-reception"
  ],
  "evolution_chain": {
    "id": 366,
    "item": null,
    "species": [
      {
        "name": "bergmite",
        "order": 712,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "avalugg",
        "order": 713,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 712,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 57.5,
    "speed": 28,
    "ability_power": 69
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
